var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3408 2C21.4454 2 22.3408 2.89543 22.3408 4V16C22.3408 17.1046 21.4454 18 20.3408 18H17.3408H15.3408H2.34082C1.23625 18 0.34082 17.1046 0.34082 16V2C0.34082 0.89543 1.23625 0 2.34082 0H8.34082C9.46082 0 10.1738 0.475451 10.8898 1.37885C10.9096 1.40385 10.9579 1.46608 11.0114 1.535L11.0115 1.53515C11.0869 1.63236 11.1727 1.74283 11.2033 1.78082C11.2343 1.81925 11.2604 1.85103 11.282 1.8773L11.282 1.87732C11.37 1.98428 11.3827 1.99978 11.3426 2H20.3408ZM14.3408 16H2.34082V2H8.34082C8.72506 2 8.94784 2.14857 9.32242 2.62116C9.33418 2.636 9.36788 2.67944 9.40987 2.73357L9.41001 2.73375L9.41002 2.73376C9.4904 2.83737 9.60109 2.98006 9.64665 3.03654C10.1495 3.65991 10.6173 3.99614 11.3355 3.99999L14.3408 3.99999V5H15.3408V6H14.3408V8H15.3408V9H14.3408V11H15.3408V12H14.3408V14H15.3408V15H14.3408V16ZM17.3408 16H20.3408V4L16.3408 3.99999V5H17.3408V7H16.3408V8H17.3408V10H16.3408V11H17.3408V13H16.3408V14H17.3408V16Z",
    fill: "#272C4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFolder);
export default __webpack_public_path__ + "static/media/ico-folder.dbfd50b266fada18c987e7e04f6d5695.svg";
export { ForwardRef as ReactComponent };